import React from 'react';
import ContactForm from '../../components/Contact/contactForm';

const GetAQuote    = () => {
    return (
        <div  style={{margin: '60px  50px',borderRadius: '20px',paddingLeft: '50px',paddingTop: '60px'}} className=''>
            <div className='row'>
                <div className='col-md-12'>
                    <h2 style={{fontWeight: '700', color: '#006FB4',fontFamily: 'Montserrat',fontSize: '42px'}} >Get a Quote</h2>
                </div>
                <div className='col-md-5 mt-3'>
                    <p style={{fontWeight: '500', color: 'black',fontFamily: 'Montserrat',fontSize: '18px',paddingRight: '200px' }} >
                    We provide everything from Drayage to Trans-loading to Cross Docking.
                    </p>

                </div>
                <div  className='col-md-7'>
                        <ContactForm />
                </div>
            </div>



        </div>
    );
}

export default GetAQuote
;


